export default function CommunityFeatures() {
  const features = [
    {
      icon: 'ri-quill-pen-line',
      title: '自由创作',
      description: '支持富文本编辑器，让你尽情挥洒文字才华，书写属于你的故事与诗篇。',
    },
    {
      icon: 'ri-chat-smile-2-line',
      title: '温暖互动',
      description: '点赞、评论、私信，多种互动方式让你与志同道合的朋友建立深度连接。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全私密',
      description: '严格的内容审核机制和隐私保护措施，为你营造安心舒适的表达空间。',
    },
    {
      icon: 'ri-rocket-line',
      title: '优质推荐',
      description: '智能算法为你推荐感兴趣的内容，发现更多与你心灵契合的文字伴侣。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="features-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 id="features-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            为什么选择文爱社区
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            我们用心打造每一个细节，只为给你最好的文字交流体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="text-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-accent-50 transition-colors duration-300 animate-fade-in-up"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-xl text-accent-600 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}